const { delaySave, promiseFetchDataAuth, promiseFetchDownloadAuth } = require('./services/promise-fetch');
const { removeChildArray } = require('./tools/data-util');
const { genQueryString } = require('./tools/utility-helper');

module.exports = {
  delaySave,
  genQueryString,
  promiseFetchDataAuth,
  promiseFetchDownloadAuth,
  removeChildArray,
  keepUserDataLocalStorage: require('./services/member').keepUserDataLocalStorage,
}